import React, { useEffect, useState } from 'react';
import Footer from '../../shared/footer/Footer';
import LoginModal from '../../main/loginModal/LoginModal';
import Head from '../../Global/Head';
import Header from '../../Global/Header';
import { AiOutlineCalendar, AiOutlineShareAlt } from 'react-icons/ai';
import { HiOutlineLocationMarker } from 'react-icons/hi';
import { BsBookmark } from 'react-icons/bs';

export default function Blog3() {
  const accessToken = localStorage.getItem("@user");
  const [isVisible, setIsVisible] = useState(!!accessToken ? false : true);
  const [topPosition, setTopPosition] = useState(50);

  useEffect(() => {
    let interval;
    const totalTime = 1500;
    const steps = 800;
    const intervalTime = totalTime / steps;
    const increment = 1300 / steps;

    if (isVisible) {
      interval = setInterval(() => {
        setTopPosition((prev) => {
          if (prev <= 0) {
            clearInterval(interval);
            return 0;
          }
          return prev - increment;
        });
      }, intervalTime);
    }

    return () => clearInterval(interval);
  }, [isVisible]);

  const slideGoDown = () => {
    const totalTime = 1500; // Total animation time
    const steps = 800; // Number of steps
    const intervalTime = totalTime / steps; // Time per step
    const increment = 1300 / steps; // Position change per step

    let interval = setInterval(() => {
      setTopPosition((prev) => {
        if (prev >= 80) {
          clearInterval(interval); // Stop the interval
          setTimeout(() => setIsVisible(false), 0); // Change state after animation ends
          return 80; // Ensure it stops at the original position
        }
        return prev + increment; // Increment position to slide down
      });
    }, intervalTime);
  };

  const BlankModal = ({ isVisible, setIsVisible }) => {
    return (
      <div
        className={`fixed inset-0 z-[1000]  transition-opacity duration-300 ${
          isVisible ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      >
        <div
          className="absolute inset-0 login-slide-up  bg-black"
          onClick={() => setIsVisible(false)}
        ></div>
        <div className="relative w-full h-screen">
          <div
            style={{ top: `${topPosition}%` }} // Dynamic top position
            className="absolute w-full h-screen transition-none"
          >
            <LoginModal setIsVisible={setIsVisible} slideGoDOwn={slideGoDown} />
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="min-h-screen ">
      <BlankModal setIsVisible={setIsVisible} isVisible={isVisible} />
      <Head />

      <Header />
      <div className="max-w-7xl mx-auto p-6">
        <h1 className="text-4xl font-bold mt-4">Conversation Starters: How to Spark Meaningful Connections</h1>
        <div className="mt-4 flex items-start justify-between">
          <div className="flex items-center gap-4 text-sm text-gray-600">
            
            <div className="flex items-center gap-2">
              <span className="inline-block bg-black text-white px-2 py-0.5 rounded">HighTable</span>
            </div>
          </div>
         
        </div>

        <div className="mt-6 rounded-lg overflow-hidden">
          <img
            src="https://res.cloudinary.com/diecfwnp9/image/upload/v1761551273/WhatsApp_Image_2025-10-27_at_08.38.53_qff0ww.jpg"
            alt="Conversation Starters"
            className="w-full h-64 sm:h-96 object-cover"
          />
        </div>

  <div className="prose max-w-none mt-6">
          <p>
            We all know the awkwardness of small talk—the endless “Hi, how are you?” loop
            that rarely leads anywhere. Conversation is the bridge to connection, and at
            Hightable we help you move beyond surface-level chat to conversations that
            actually matter.
          </p>

          <h2>Why conversation starters matter</h2>
          <p>
            Humans crave connection, but opening up isn’t always easy. A great conversation
            starter is an invitation: it signals curiosity, openness, and genuine interest.
            Done well, it can turn a stranger into a meaningful connection in minutes.
          </p>

          <h2>Tips for starting real conversations</h2>
          <ol>
            <li>
              <strong>Go beyond “How are you?”</strong>
              <p>
                Instead of generic questions, try prompts that invite stories or opinions,
                for example: “What’s something you’re excited about this week?” or “Have you
                read or watched anything interesting lately?” These small tweaks make
                conversations feel alive instead of obligatory.
              </p>
            </li>
            <li>
              <strong>Observe and comment</strong>
              <p>
                The environment is full of cues—a book, a piece of art, or even someone’s
                coffee. Noticing details shows attentiveness and can spark a natural,
                context-driven conversation.
              </p>
            </li>
            <li>
              <strong>Share first, then ask</strong>
              <p>
                Vulnerability invites vulnerability. Share a small anecdote, then open the
                floor: “I just tried a new workout that left me exhausted but happy. How do
                you usually stay active?” This makes the interaction feel reciprocal rather
                than interrogative.
              </p>
            </li>
            <li>
              <strong>Use humor and playfulness</strong>
              <p>
                Light-hearted comments or gentle humor break tension and instantly make
                someone more comfortable. Shared laughter is a fast route to connection.
              </p>
            </li>
          </ol>

          <h2>How Hightable helps</h2>
          <p>
            Hightable creates spaces where conversation starters flow naturally—through
            interest-based prompts, shared activities, or serendipitous matches. The
            platform supports genuine interaction without forcing it, helping people move
            from “Hi” to a meaningful dialogue.
          </p>

          <h2>The ripple effect</h2>
          <p>
            A single conversation can be transformative: it can spark friendship,
            collaboration, mentorship, or even love. Starting a real conversation is an act
            of building belonging. Hightable helps people create connections that matter,
            one conversation at a time.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}